export var ValuePedigreeLinkageType;
(function (ValuePedigreeLinkageType) {
    ValuePedigreeLinkageType["Adopted"] = "adopted";
    ValuePedigreeLinkageType["Birth"] = "birth";
    ValuePedigreeLinkageType["Foster"] = "foster";
})(ValuePedigreeLinkageType || (ValuePedigreeLinkageType = {}));
//# sourceMappingURL=ValuePedigreeLinkageType.js.map